import {
  SupplierApiError,
  mapSupplierApiError,
  supplierGetAndParse,
  supplierPostAndParse,
} from './supplierApiCore';
import {
  supplierConnectionAndRequestCommandResponseV1Schema,
  supplierConnectionCommandResponseV1Schema,
  supplierDataRequestCommandResponseV1Schema,
  supplierInboxResponseV1Schema,
} from './supplierInboxContracts';

export const SUPPLIER_INBOX_ENDPOINTS = Object.freeze({
  inbox: '/supplier/inbox',
  acceptConnection: (connectionId) => `/supplier/connections/${connectionId}/accept`,
  declineConnection: (connectionId) => `/supplier/connections/${connectionId}/decline`,
  terminateConnection: (connectionId) => `/supplier/connections/${connectionId}/terminate`,
  acceptRequest: (requestId) => `/supplier/requests/${requestId}/accept`,
  declineRequest: (requestId) => `/supplier/requests/${requestId}/decline`,
  cancelRequest: (requestId) => `/supplier/requests/${requestId}/cancel`,
  acceptConnectionAndRequest: (connectionId, requestId) =>
    `/supplier/connections/${connectionId}/requests/${requestId}/accept`,
});

export class SupplierInboxApiError extends SupplierApiError {
  constructor(payload, httpStatus) {
    super(payload, httpStatus, 'Supplier inbox request failed');
    this.name = 'SupplierInboxApiError';
  }
}

const mapApiError = (error) => mapSupplierApiError(error, SupplierInboxApiError);

const getAndParse = (endpoint, schema) => supplierGetAndParse(endpoint, schema, mapApiError);
// Every inbox command carries the same empty body — the domain wrapper fixes
// it so call sites keep the (endpoint, schema) shape they already had.
const postAndParse = (endpoint, schema) => supplierPostAndParse(endpoint, {}, schema, mapApiError);

export const fetchSupplierInbox = () =>
  getAndParse(SUPPLIER_INBOX_ENDPOINTS.inbox, supplierInboxResponseV1Schema);

export const acceptSupplierConnection = (connectionId) =>
  postAndParse(
    SUPPLIER_INBOX_ENDPOINTS.acceptConnection(connectionId),
    supplierConnectionCommandResponseV1Schema,
  );

export const declineSupplierConnection = (connectionId) =>
  postAndParse(
    SUPPLIER_INBOX_ENDPOINTS.declineConnection(connectionId),
    supplierConnectionCommandResponseV1Schema,
  );

export const terminateSupplierConnection = (connectionId) =>
  postAndParse(
    SUPPLIER_INBOX_ENDPOINTS.terminateConnection(connectionId),
    supplierConnectionCommandResponseV1Schema,
  );

export const acceptSupplierRequest = (requestId) =>
  postAndParse(
    SUPPLIER_INBOX_ENDPOINTS.acceptRequest(requestId),
    supplierDataRequestCommandResponseV1Schema,
  );

export const declineSupplierRequest = (requestId) =>
  postAndParse(
    SUPPLIER_INBOX_ENDPOINTS.declineRequest(requestId),
    supplierDataRequestCommandResponseV1Schema,
  );

export const cancelSupplierRequest = (requestId) =>
  postAndParse(
    SUPPLIER_INBOX_ENDPOINTS.cancelRequest(requestId),
    supplierDataRequestCommandResponseV1Schema,
  );

export const acceptSupplierConnectionAndRequest = ({ connectionId, requestId }) =>
  postAndParse(
    SUPPLIER_INBOX_ENDPOINTS.acceptConnectionAndRequest(connectionId, requestId),
    supplierConnectionAndRequestCommandResponseV1Schema,
  );
